package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initInvalid_token_has_been_provided_token_invalidPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/invalid_token_has_been_provided_token_invalid.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/invalid-token-has-been-provided-token-invalid")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Invalid_token_has_been_provided_token_invalidPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("invalid-token-has-been-provided-token-invalid") }) {
        org.jetbrains.compose.web.dom.Text("Invalid Token has been provided / TOKEN_INVALID")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You have one of the following issues with the bot token in your code:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("You have provided an invalid token in your code. Reset it on the Discord Developer Portal, then paste the new token into your code.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("You are not loading the token correctly. If you are using a ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("config.json")
            }
            org.jetbrains.compose.web.dom.Text(" file, follow the discord.js guide on how to load it. If you are using a ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text(".env")
            }
            org.jetbrains.compose.web.dom.Text(" file, make sure that you are using the dotenv module correctly. Check the package documentation or contact their support if needed.")
        }
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.NOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" This issue is unrelated to the hosting service. It originates from your code. The server runs what you upload to it, nothing more and nothing less.")
        }
    }
}
